import React, { useState } from "react";
import Cookies from "js-cookie";
import Link from "next/link";
import { Transition } from "@headlessui/react";
import Button from "../Buttons/Button/Button";
import Typography from "../Typography/Typography";
import Icon from "../Icon/Icon";

const COOKIE_BANNER_COOKIE_NAME = "cookie_confirm";
interface Props {
    onClose?: () => void;
}

const CookieBanner = ({ onClose }: Props) => {
    const [isOpen, setIsOpen] = useState(Cookies.get(COOKIE_BANNER_COOKIE_NAME) !== "true");

    const onConfirmClick = () => {
        if (onClose) onClose();
        Cookies.set(COOKIE_BANNER_COOKIE_NAME, "true", { expires: 90 });
        setIsOpen(false);
    };

    return (
        <Transition
            show={isOpen}
            leave="transition-opacity transition-[max-height] duration-200"
            leaveFrom="opacity-100 max-h-[200px]"
            leaveTo="opacity-0 max-h-[0px]"
        >
            <div className="bg-velvet-900 flex flex-row justify-between p-0.75">
                <div className="flex gap-0.75 text-velvet-500 w-3/4 items-center">
                    <Icon icon="info" width={24} height={24} />
                    <Typography as="span" variant="label">
                        This site uses cookies
                    </Typography>
                </div>
                <div className="flex items-center gap-0.75 shrink-0">
                    <Link href="./Cookies">
                        <Typography as="span" variant="inlineLink" accent="underline">
                            Cookie Policy
                        </Typography>
                    </Link>
                    <Button variant="secondary" size="small" onClick={onConfirmClick}>
                        ok, got it
                    </Button>
                </div>
            </div>
        </Transition>
    );
};

export default CookieBanner;
